<template>
  <div class="tour-guide-ringing">
    <div
      v-if="customBranding"
      class="tour-guide-portrait"
    >
      <img
        v-if="portrait"
        :src="portrait"
      >
      <i
        v-else
        class="isif isif-man"
      />
    </div>
    <div
      v-else
      class="tour-guide-portrait"
    >
      <img :src="iStagingPortrait">
    </div>
    <p class="tour-guide-name">
      {{ name }}
    </p>
    <template v-if="responseText">
      <div class="tour-guide-status">
        <p class="tour-guide-status-text">
          {{ $t(responseText) }}
        </p>
        <p>
          {{ $t('tourring.response') }}
        </p>
      </div>
      <div class="tour-guide-result-btn">
        <button @click="$emit('showCalendar')">
          <i class="isif isif-reserve" />
          {{ $t('tourring.goToReserve') }}
        </button>
      </div>
    </template>
    <template v-else>
      <div class="tour-guide-status">
        <p class="tour-guide-status-text">
          {{ $t('tourring.dialing') }}
          <span class="tour-guide-ringing-mark">{{ ringingMark }}</span>
        </p>
      </div>
      <div class="tour-guide-hint">
        <p>{{ $t('tourring.dialingHint') }}</p>
      </div>
      <div class="tour-guide-ringing-btn">
        <button @click="openConfrimModal">
          <i class="isif isif-phone" />
        </button>
      </div>
    </template>
    <IModal
      ref="confirmModal"
      bgcolor="transparent"
      :closeable="false"
    >
      <div class="tour-guide-confirm-modal">
        <p>{{ formData.name }}</p>
        <p>{{ $t('tourring.handupPhoneHint') }}</p>
        <p>{{ $t('tourring.handupPhoneHint2') }}</p>
        <div class="tour-guide-confirm-action">
          <button
            class="cancel"
            @click="closeConfrimModal"
          >
            <i class="isif isif-close" />
            {{ $t('cancel') }}
          </button>
          <button
            class="confirm"
            @click="hangUpPhone"
          >
            <i class="isif isif-check" />
            {{ $t('confirm') }}
          </button>
        </div>
      </div>
    </IModal>
  </div>
</template>

<script>
// import _ from 'lodash'
import IModal from '@/components/IModal'
import { mapGetters } from 'vuex'
import { requestConnection, putMissedCall } from '@/services/api/tour-ring'
import iStagingPortrait from '@/assets/images/istaging.svg'
import { tourRingSVC } from '@/plugins/axios/services'

export default {
  name: 'RingingIndex',
  components: {
    IModal
  },

  props: {
    formData: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      activeRingingId: null,
      iStagingPortrait,
      ringingMark: '',
      hasRecordMissedCall: false,
      roomId: null,
      callTimes: 0,
      responseText: ''
    }
  },

  computed: {
    ...mapGetters([
      'user',
      'property',
      'currentBuilding'
    ]),

    profile () {
      const {
        showAdminProfile,
        adminProfile
      } = this.user

      return showAdminProfile && adminProfile ? adminProfile : this.user
    },

    portrait () {
      // if (_.has(this.profile.portrait, 'cutUrl')) {
      //   return this.profile.portrait.cutUrl
      // }
      return this.profile.profileUrl || null
    },

    customBranding () {
      const { customSetting } = this.profile
      return customSetting.customBranding
    },

    name () {
      let name = 'iStaging'
      if (this.customBranding) {
        name = this.profile.name
      }
      return name || this.$t('None')
    },

    companyDisplayName () {
      const company = this.profile.companyDisplayName
      return this.customBranding ? company : null
    }
  },

  beforeMount () {
    window.addEventListener('beforeunload', this.popupLeaveHint)
    window.addEventListener('unload', this.recordMissedCall)
  },

  mounted () {
    this.startCall()
    this.activeRingingId = setInterval(() => {
      this.activeRinging()
    }, 700)
  },

  beforeDestroy () {
    clearInterval(this.activeRingingId)
    window.removeEventListener('beforeunload', this.popupLeaveHint)
    window.removeEventListener('unload', this.recordMissedCall)
  },

  methods: {
    activeRinging () {
      switch (this.ringingMark.length) {
        case 0:
        case 1:
        case 2:
          this.ringingMark += '.'
          break
        case 3:
          this.ringingMark = ''
          break
        default:
          break
      }
    },

    popupLeaveHint (event) {
      event.returnValue = ''
      return ''
    },

    async recordMissedCall () {
      if (this.hasRecordMissedCall) return
      try {
        await putMissedCall(this.roomId)
        this.hasRecordMissedCall = true
      } catch (error) {
        console.log(error)
      }
    },

    openConfrimModal () {
      this.$refs.confirmModal.show()
    },

    closeConfrimModal () {
      this.$refs.confirmModal.hide()
    },

    async hangUpPhone () {
      await this.recordMissedCall()
      this.closeConfrimModal()
      this.$emit('hide')
    },

    async startCall () {
      try {
        // 待 Tourring 支援 group 後再啟用這段
        // const caseObject = {}
        // if (this.property.objectId) {
        //   caseObject.propertyId = this.property.objectId
        // } else {
        //   caseObject.buildingId = this.currentBuilding.objectId
        // }
        const caseObject = { buildingId: this.currentBuilding.objectId } // 支援 group 後這段拿掉
        const payload = Object.assign({}, this.formData, caseObject)
        const result = await requestConnection(payload)
        this.connectionResponseHandler(result)
      } catch (error) {
        this.responseText = 'tourring.noPushId'
        console.log(error)
      }
    },

    connectionResponseHandler ({ status, roomId }) {
      if (roomId) {
        this.roomId = roomId
      }
      switch (status) {
        case 0:
          setTimeout(() => {
            this.callTimes++
            this.getRoomStatus()
          }, 5000)
          break
        case 1:
          this.openTourring()
          break
        case 2:
          this.responseText = 'tourring.noPushId'
          break
        case 3:
          this.responseText = 'tourring.busy'
          break
        default:
          break
      }
    },

    async getRoomStatus () {
      if (this.callTimes >= 7) {
        this.responseText = 'tourring.noAnswer'
        this.recordMissedCall()
        return
      }
      const result = await tourRingSVC.getRoomStatus(this.roomId)

      if (result.success) {
        const { startedAt, endAt } = result.data
        if (startedAt && !endAt) {
          this.openTourring()
        } else {
          setTimeout(() => {
            this.callTimes++
            if (this.hasRecordMissedCall) return
            this.getRoomStatus()
          }, 5000)
        }
      } else {
        console.error(result.resultMessage)
        this.responseText = 'tourring.noAnswer'
      }
    },

    openTourring () {
      this.$emit('hide')
      this.$router.push(`/tour-ring/${this.currentBuilding.objectId}?roomId=${this.roomId}`)
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main';
@import '~css/common/extends';

p {
  text-shadow: none;
  color: $black;
  text-align: center;
  margin-top: 8px;
}

.tour-guide-ringing {
  padding: 2rem;
  max-width: 90vw;
  width: 360px
  background-color: $white
}

.tour-guide-portrait {
  width: 100px;
  height: 100px;
  margin: 23px auto 0 auto;
  border-radius: 50%;
  overflow: hidden;

  img {
    display: inline-block;
    width: 100%;
  }

  i {
    font-size: 100px;
  }
}

.tour-guide-name {
  margin: 16px auto;
  font-size: 1.2rem;
}

.tour-guide-status, .tour-guide-hint {
  margin-top: 16px;
  font-size: 0.9rem;
  text-align: center;

  .tour-guide-status-text {
    display: inline-block;
    margin: 8px auto 0 auto;
    position: relative;
  }
}

.tour-guide-ringing-mark {
  position: absolute;
  left: 100%;
  text-shadow: none;
  color: $black;
}

.tour-guide-ringing-btn {
  margin-top: 48px;
  text-align: center;

  button {
    width: 60px;
    height : 60px;
    background-color: $red;
    border-radius: 50%;
    color: $white;
  }

  i {
    font-size: 48px;
  }
}

.tour-guide-result-btn {
  margin-top: 48px;
  text-align: center;

  button {
    padding: 8px;
    background-color: $black;
    color: $white;
  }
}

.tour-guide-confirm-modal {
  background-color: $white;
  padding: 2rem 4rem;
  border: 1px solid $black;
  border-radius: 20px;
  color: $black;
}

.tour-guide-confirm-action {
  margin-top: 20px;

  .cancel {
    background-color: $dark-red;
    color: $light-pink-color;
    box-shadow: 1px 1px 4px $light-pink-color;
  }

  .confirm {
    background-color: $white;
    color: $el-success;
    border: 1px solid $gray
    margin-left: 20px;
  }

  button {
    font-size: 0.9rem;
    display: inline-block;
    padding: 4px 8px;
    border-radius: 4px;
  }
}
</style>
